var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"real-estate-data-tab"},[_c('div',{staticClass:"empty-data-container"},[_c('div',{staticClass:"empty-icon"},[_c('i',{staticClass:"el-icon-office-building"})]),_c('div',{staticClass:"empty-text"},[_vm._v("暂无不动产数据")]),_c('div',{staticClass:"empty-description"},[_vm._v("当前没有相关的不动产信息记录")])])])
}]

export { render, staticRenderFns }